<template>
  <v-app class="page-home">
    <!-- Navigation -->
    <v-app-bar app class="tw:shadow-none! tw:py-0! tw:sm:py-5! tw:bg-white!">
      <v-container class="header">
        <div class="tw:flex tw:text-center tw:items-center tw:justify-center!">
          <img src="/logo.svg" height="20px" class="tw:h-[27px] logo" />
          <v-spacer class="tw:hidden! tw:sm:block!" />
          <v-btn
            @click="router.push(URLs.PAGE_AUTH_LOGIN)"
            rounded
            variant="elevated"
            color="#000"
            class="v-btn-get-started tw:hidden! tw:sm:block!"
            >Get Started</v-btn
          >
        </div>
      </v-container>
    </v-app-bar>

    <!-- Hero Section -->
    <v-main class="tw:py-5! tw:sm:py-10! tw:mt-15!">
      <v-container class="tw:mt-3! tw:sm:mt-6! tw:px-3! tw:sm:px-0!">
        <v-row class="tw:translate-y-[-38px]">
          <v-col cols="12" md="6" class="tw:flex tw:flex-col tw:justify-center">
            <h1
              class="tw:font-bold! tw:text-4xl tw:md:text-6xl tw:lg:text-[60px] tw:xl:text-[80px] tw:text-center tw:lg:text-left tw:mb-2! tw:max-w-[750px]!"
            >
              Dominate Your Local Market
            </h1>
            <div class="tw:px-4! tw:md:px-1!">
              <p class="tw:mb-3! tw:md:mt-4! tw:text-center tw:lg:text-left tw:text-lg!">
                Enterprise-Level SEO Reporting, Without the Enterprise Price.
              </p>
            </div>
            <div class="tw:text-center tw:mt-2! tw:md:mt-4! tw:lg:text-left">
              <v-btn
                @click="router.push(URLs.PAGE_AUTH_LOGIN)"
                rounded
                variant="elevated"
                color="#000"
                class="v-btn-get-started"
                >Get Started</v-btn
              >
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="tw:p-10! tw:sm:p-20! tw:md:p-5! tw:pt-5!">
              <v-img
                src="/assets/images/vector_smart_object_6.png"
                class="hero-image"
                contain
              ></v-img>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card
              class="tw:mx-auto! tw:py-10! gradient-background tw:shadow-none! tw:text-center! tw:p-4!"
              color="white"
              elevation="4"
              rounded="xl"
            >
              <h2 class="tw:text-2xl tw:mb-2! tw:font-bold! tw:max-w-[850px]! tw:mx-auto!">
                Powerful, consolidated SEO reporting built for your local business
              </h2>
              <p class="tw:mb-2! tw:max-w-[850px]! tw:mx-auto!">
                Stop guessing about your digital visibility and start growing with insights usually
                reserved for big brands. Running a local business is tough. There's a lot to juggle,
                and keeping track of your online presence shouldn't be another headache.
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <!-- Features Section -->
    <v-container id="features" class="px-0 tw:px-3! tw:sm:px-0!">
      <h2 class="tw:text-2xl tw:mb-2! tw:md:mb-6! tw:font-bold! tw:text-center">
        Why THOR is Perfect for Local Businesses
      </h2>
      <v-row>
        <v-col cols="12" sm="6" lg="3" v-for="feature in features" :key="feature.title">
          <v-card class="tw:p-6! gradient-background" outlined @click="" height="100%" rounded="xl">
            <img :src="feature.icon" class="tw:h-[36px] tw:mb-3!" />
            <h3 class="text-h6 font-weight-medium mb-2 tw:font-bold!">{{ feature.title }}</h3>
            <p>{{ feature.text }}</p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Features Section -->
    <v-container id="features" class="px-0 tw:px-3! tw:sm:px-0! tw:md:mt-4!">
      <div class="tw:text-center">
        <v-btn
          @click="router.push(URLs.PAGE_AUTH_LOGIN)"
          rounded
          variant="elevated"
          color="#000"
          class="v-btn-get-started"
          >Get Started</v-btn
        >
      </div>
    </v-container>

    <!-- CTA Section -->
    <v-container class="py-12 tw:px-3! tw:sm:px-0!">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <div class="tw:max-w-[480px] tw:mx-auto!">
            <h2 class="tw:text-2xl tw:mb-2! tw:font-bold! tw:text-center">
              Save Time & Grow Faster
            </h2>
            <p>
              Stop wasting hours manually pulling data and creating reports from multiple sources.
              THOR automates the process, letting you focus on what you do best - serving your local
              community.
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Reports Section -->
    <v-container id="reports" class="tw:pt-0! tw:px-3! tw:sm:px-0!">
      <v-row>
        <v-col cols="12" md="6">
          <v-row class="reports-row">
            <v-col cols="12" v-for="report in reports" :key="report.title">
              <v-sheet class="pa-4" border-left color="transparent" elevation="0">
                <h3 class="text-subtitle-1 tw:font-bold!">{{ report.title }}</h3>
                <p class="text-body-2">{{ report.note }}</p>
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <div class="tw:p-4!">
            <img src="/assets/images/vector_smart_object.png" alt="" />
          </div>
        </v-col>
      </v-row>
    </v-container>

    <main style="background-color: #f9fafb" class="tw:pt-0! tw:px-3! tw:sm:px-0!">
      <!-- Data Access -->
      <v-container class="tw:mt-1!">
        <v-expansion-panels>
          <v-expansion-panel
            text="We connect to your accounts (Google Analytics, Google Search Console, Facebook, etc.) to gather the information that's vital for your local SEO success. This allows THOR to generate comprehensive reports and provide you with the insights you need to attract more local customers. We handle your data with the utmost care, following strict security protocols."
            title="Why We Need Access to Your Data"
          ></v-expansion-panel>
          <v-expansion-panel
            text="We know your business data is valuable. THOR uses industry-leading security to protect your information. We only access the data necessary to provide you with our local-focused reporting services, and we handle it responsibly, in accordance with our privacy policy."
            title="Your Local Data is Secure"
          ></v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </main>

    <!-- Footer -->
    <v-footer color="#192a40" class="white--text tw:pt-0! pb-2">
      <v-container>
        <v-row justify="space-between">
          <v-col cols="12" md="8" lg="9" class="tw:px-0!">
            <div class="tw:text-center tw:sm:text-left">
              <span class="text-h6 font-weight-bold">THOR for Local SEO</span>
            </div>
            <p class="tw:text-gray-300 tw:text-center tw:sm:text-left">
              Powerful, consolidated SEO reporting built for your local business.
            </p>
          </v-col>

          <v-col cols="12" md="4" lg="3">
            <v-row>
              <v-col cols="6" class="tw:px-0! tw:text-center tw:sm:text-left">
                <p><a :href="URLs.PAGE_PRIVACY" class="tw:text-gray-300!">Privacy Policy</a></p>
              </v-col>
              <v-col cols="6" class="tw:px-0! tw:text-center">
                <p><a :href="URLs.PAGE_TERMS" class="tw:text-gray-300!">Terms Of Service</a></p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-divider class="my-6"></v-divider>
        <p class="text-center text-grey-lighten-1">
          © {{ moment().format("YYYY") }} THOR for Local SEO. All rights reserved.
        </p>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script setup lang="ts">
import { URLs } from "@/constants";
import moment from "moment";
import { useRouter } from "vue-router";

const router = useRouter();

const features = [
  {
    icon: "/assets/images/vector_smart_object_2.png",
    title: "Local Visibility - Simplified",
    text: "See how your Google Business Profile, local directories, and online reviews are impacting your search performance and visibility online."
  },
  {
    icon: "/assets/images/vector_smart_object_3.png",
    title: "Customer Engagement - Centralized",
    text: "rack online reviews, website traffic, and search engine rankings - all in one dashboard. Understand how customers are finding and interacting with your business online."
  },
  {
    icon: "/assets/images/vector_smart_object_4.png",
    title: "Actionable Insights - Localized",
    text: "Get clear, easy-to-understand reports that give you actionable insights and opportunities to attract more customers in your market area."
  },
  {
    icon: "/assets/images/vector_smart_object_5.png",
    title: "Reporting Playing Field - Leveled",
    text: "Gain access to the same powerful SEO tools and insights that big brands use, without the hefty price tag."
  }
];

const reports = [
  {
    title: "Local search rankings and visibility",
    note: "(Google Search Console & Business Profile)"
  },
  {
    title: "Customer reviews and ratings across multiple platforms",
    note: "(Google, Facebook, etc.)"
  },
  { title: "Online customer review sentiment and business response metrics", note: "" },
  {
    title: "Local business directory listing consistency and accuracy",
    note: "(Apple Maps, Bing, etc.)"
  },
  {
    title: "Website traffic from all sources, including organic search traffic",
    note: "(Including Google Analytics)"
  }
];
</script>
